<template>
  <div class="box">
    <sc-page-loading v-if="loading" />
    <sc-chart :options="chartData" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScChart,
  ScPageLoading,
} from '@intelipost-js/secure-components';

const {
  mapGetters,
  mapActions,
  mapState,
} = createNamespacedHelpers('recon/analytics/monthlyRevenue');

export default {
  name: 'sc-analytics-monthly-revenue',
  computed: {
    ...mapState([
      'loading',
    ]),
    ...mapGetters([
      'dataValues',
      'months',
    ]),
    chartData() {
      return {
        title: {
          text: 'Faturamento Mensal',
        },

        yAxis: {
          title: {
            text: 'Custo Total de Frete',
          },
        },

        xAxis: {
          categories: this.months,
        },

        tooltip: {
          pointFormat: 'Valor total Liberado para Pagamento: <b>{point.y:.1f}</b> R$',
        },

        series: [
          {
            name: 'Pedidos Liberados para Pagamento',
            color: '#9bbd45',
            data: this.dataValues,
          },
        ],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom',
                },
              },
            },
          ],
        },

      };
    },
  },
  methods: {
    ...mapActions([
      'getMonthlyRevenue',
    ]),
    loadData(form) {
      return this.getMonthlyRevenue(form);
    },
  },
  components: {
    ScChart,
    ScPageLoading,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-monthly-revenue/ScAnalyticsMonthlyRevenue.vue